import React from "react";
import Filmstrip from './Filmstrip';

export default function BlogList({blogEntries}) {
  const blogs = blogEntries.map((blogEntry, index) => {
    const { Title, ImageUrl, BlogPostUrl } = blogEntry;

    // return (
    //   <li key={index}>
    //     <a href={BlogPostUrl}>{Title}</a>
    //   </li>
    // )

    return (
      <div className="strip-item thumbnail" key={index}>
        <a target="_blank" href={BlogPostUrl} className="g-link">
          <img
              u="image"
              src={ImageUrl}
              title={Title}
              border="0"
          />
          <div className="text-center g-caption">{Title}</div>
        </a>
      </div>
    );
  });

  return (
    <div className="gallery-items-list">
      <div className="panel-group">
        <div className="image-gallery-block">
          <Filmstrip increment={500}>
            {blogs}
          </Filmstrip>
        </div>
      </div>
    </div>
  );
}